import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'
import store from '@/store'
const environment = store.state.env.mode
if ('local' !== environment) {
  Sentry.init({
    Vue,
    dsn: 'https://a4c6f6e0c770c482bb648588a3b11dd8@o4507705552666624.ingest.us.sentry.io/4507705945686016',
    environment,
    integrations: [
      new BrowserTracing({
        //   routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        //   tracePropagationTargets: ['localhost', 'buy', /^\//],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  })
}
